import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_lg",
  "use": "icon-arrow_lg-usage",
  "viewBox": "0 0 20 37",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 37\" id=\"icon-arrow_lg\">\n<path fill-rule=\"evenodd\" d=\"M18.471,19.207 L1.500,36.178 L0.793,35.470 L17.763,18.500 L0.793,1.529 L1.500,0.822 L18.471,17.793 L19.178,18.500 L18.471,19.207 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol